export const LANGUAGE_KEY = 'app.languageloreal';
